"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPaymentInvalid = exports.isInvalidDollarAmount = void 0;
// libraries
var dr_platform_types_1 = require("@makemydeal/dr-platform-types");
function isInvalidDollarAmount(value) {
    return value === null || isNaN(value);
}
exports.isInvalidDollarAmount = isInvalidDollarAmount;
function isPaymentInvalid(payment, offerType, offerPrice) {
    var isCashOfferType = offerType === dr_platform_types_1.OFFER_TYPE.cash;
    if (isCashOfferType && offerPrice === 0) {
        return true;
    }
    else if (!isCashOfferType) {
        return isInvalidDollarAmount(payment);
    }
    return false;
}
exports.isPaymentInvalid = isPaymentInvalid;
